import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_HCPCS_REQUEST, fetchHcpcsSuccess, fetchHcpcsFailure,
  CREATE_HCPC_REQUEST, createHcpcSuccess, createHcpcFailure,
  UPDATE_HCPC_REQUEST, updateHcpcSuccess, updateHcpcFailure,
  DELETE_HCPC_REQUEST, deleteHcpcSuccess, deleteHcpcFailure,
  FETCH_HCPC_RULES_REQUEST, fetchHcpcRulesSuccess, fetchHcpcRulesFailure,
  MAP_HCPC_TO_RULE_REQUEST, mapHcpcToRuleSuccess, mapHcpcToRuleFailure,
  DELETE_HCPC_RULE_MAPPING_REQUEST, deleteHcpcRuleMappingSuccess, deleteHcpcRuleMappingFailure
} from '../actions/hcpcActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchHcpcs(action) {
  try {
    const token = getAuthToken();
    const {  page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching Hcp with payload: ", action.payload);

    // const response = yield call(axios.get, `${API_BASE_URL}/icd`, createConfig());
    const response = yield call(
      axios.get,
      `${getBaseUrl()}/hcpc`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );
    yield put(fetchHcpcsSuccess(response.data));
  } catch (error) {
    yield put(fetchHcpcsFailure(error.message));
  }
}

function* createHcpc(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/hcpc`, action.payload, createConfig());
    yield put(createHcpcSuccess(response.data));
  } catch (error) {
    yield put(createHcpcFailure(error.message));
  }
}

function* updateHcpc(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/hcpc/${id}`, data, createConfig());
    yield put(updateHcpcSuccess(response.data));
  } catch (error) {
    yield put(updateHcpcFailure(error.message));
  }
}

function* deleteHcpc(action) {
  try {
    yield call(axios.delete, `${API_BASE_URL}/hcpc/${action.payload}`, createConfig());
    yield put(deleteHcpcSuccess(action.payload));
  } catch (error) {
    yield put(deleteHcpcFailure(error.message));
  }
}

function* fetchHcpcRules(action) {
  try {
    const { projectId, hcpcId } = action.payload;
    const response = yield call(axios.get, `${API_BASE_URL}/hcpc/${projectId}/${hcpcId}/rules`, createConfig());
    yield put(fetchHcpcRulesSuccess(response.data));
  } catch (error) {
    yield put(fetchHcpcRulesFailure(error.message));
  }
}

function* mapHcpcToRule(action) {
  try {
    const { projectId, hcpcId, ruleId } = action.payload;
    yield call(axios.put, `${API_BASE_URL}/hcpc/${projectId}/${hcpcId}/rules/${ruleId}`, {}, createConfig());
    yield put(mapHcpcToRuleSuccess());
  } catch (error) {
    yield put(mapHcpcToRuleFailure(error.message));
  }
}

function* deleteHcpcRuleMapping(action) {
  try {
    const { projectId, hcpcId, ruleId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/hcpc/${projectId}/${hcpcId}/rules/${ruleId}`, createConfig());
    yield put(deleteHcpcRuleMappingSuccess());
  } catch (error) {
    yield put(deleteHcpcRuleMappingFailure(error.message));
  }
}

export default function* hcpcSaga() {
  yield takeLatest(FETCH_HCPCS_REQUEST, fetchHcpcs);
  yield takeLatest(CREATE_HCPC_REQUEST, createHcpc);
  yield takeLatest(UPDATE_HCPC_REQUEST, updateHcpc);
  yield takeLatest(DELETE_HCPC_REQUEST, deleteHcpc);
  yield takeLatest(FETCH_HCPC_RULES_REQUEST, fetchHcpcRules);
  yield takeLatest(MAP_HCPC_TO_RULE_REQUEST, mapHcpcToRule);
  yield takeLatest(DELETE_HCPC_RULE_MAPPING_REQUEST, deleteHcpcRuleMapping);
}
